export default __webpack_public_path__ + "static/media/apple_store.ac0abe63.png";